export default __webpack_public_path__ + "static/media/companies_empty_state.e00f99f3.svg";